<template>
  <el-form v-model="search"
           :inline="true">
    <el-form-item>
      <el-checkbox-group v-model="search.active"
                         :max="1">
        <el-checkbox-button v-for="(option, index) in OptionActive"
                            :label="index + 1"
                            :key="index">{{option}}</el-checkbox-button>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item>
      <el-checkbox-group v-model="search.p2p_enabled"
                         :max="1">
        <el-checkbox-button v-for="(option, index) in OptionWsapEta"
                            :label="index + 1"
                            :key="index">{{option}}</el-checkbox-button>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item>
      <el-select v-model="search.enterprise_id"
                 placeholder="EMPRESA"
                 filterable
                 no-match-text="No existen coincidencias"
                 no-data-text="Cargando..."
                 clearable>
        <el-option  v-for="enterprise in enterprises"
                    :key="enterprise.id"
                    :label="enterprise.name"
                    :value="enterprise.id"/>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-select v-model="search.distribution_center_id"
                 placeholder="CT"
                 filterable
                 no-match-text="No existen coincidencias"
                 no-data-text="Cargando..."
                 clearable>
        <el-option  v-for="distribution_center in distribution_centers"
                    :key="distribution_center.id"
                    :label="distribution_center.name"
                    :value="distribution_center.id"/>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-input v-model="search.patent"
                placeholder="EJ: AAA-123"
                clearable/>
    </el-form-item>
    <el-form-item>
      <el-button  class="default"
                  @click="handleSearch">
        <i class="fa fa-search"/>
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { cachedAPIRequest } from '../../../mixins/cacheDim';

export default {
  name: 'Search',
  data() {
    return {
      OptionActive: ['Activado', 'Desactivado'],
      OptionWsapEta: ['Con Wsap. ETA', 'Sin Wsap. ETA'],
      search: {
        patent: '',
        active: [],
        p2p_enabled: [],
        enterprise_id: '',
        distribution_center_id: '',
      },
      enterprises: [],
      distribution_centers: [],
    };
  },
  mounted() {
    this.getEnterprises();
    this.getDistributionCenters();
  },
  methods: {
    getEnterprises() {
      cachedAPIRequest({
        module: 'planning',
        service: 'enterprises',
        params: { limit: 6000 },
      }).then((response) => {
        this.enterprises = response.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar empresas',
        });
      });
    },
    getDistributionCenters() {
      cachedAPIRequest({
        module: 'planning',
        service: 'distribution_centers',
        params: { limit: 1000 },
      }).then((response) => {
        this.distribution_centers = response.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar los ct',
        });
      });
    },
    handleSearch() {
      this.$emit('search', this.search);
    },
  },
};
</script>

<style lang="scss" scoped>
  .el-button { height: 40px; }
</style>
